// API
import * as API  from './api';

let url = process.env.REACT_APP_PUBLIC_URL_HOST;

const facebookAuthUrl = `https://www.facebook.com/v2.12/dialog/oauth?client_id=176430263121482&redirect_uri=${url}/sign-up/complete-facebook-sign-up?&response_type=code&scope=public_profile,email`;

export const startFacebookAuth = (event) => {
  window.location.href = facebookAuthUrl;
}

export const startTwitterAuth = (event) => {
  return new Promise((resolve, reject) => {
    API.twitterRequestToken()
    .then((response) => {
      if (response.error) {
        reject(response.error);
      } else {
        resolve({
          auth_url: response.auth_url
        })
      }
    })
  });
}



// WEBPACK FOOTER //
// ./src/utils/social.js